// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Group (two people) icon with a "+" badge in the bottom-right corner.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function GroupPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14 14.077A8 8 0 0 0 2 21" />
      <path d="M18 15v6" />
      <path d="M18.994 11a5 5 0 0 0-1.444-7.3" />
      <path d="M21 18h-6" />
      <circle cx="10" cy="8" r="5" />
    </svg>
  );
}
